var map = {
	"./blankIcon.svg": 1578,
	"./csvIcon.svg": 1956,
	"./docIcon.svg": 1957,
	"./htmlIcon.svg": 1958,
	"./pdfIcon.svg": 1959,
	"./pptxIcon.svg": 1960,
	"./videoIcon.svg": 1577,
	"./xlsIcon.svg": 1961
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1955;